module.exports = __webpack_public_path__ + "static/media/bad.6fad1cd9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/emojis/bad.gif
// module id = 166
// module chunks = 0